import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import TopHeader from "../Dashoboard/TopHeader";
import AddIcon from "@mui/icons-material/Add";
import { editIcon, viewIcon } from "../../assets/img";
import ReactPaginate from "react-paginate";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { saveLoader } from "../../redux/slice/loaderNoti";
import Swal from "sweetalert2";
import DatePicker from "react-datepicker";
import moment from "moment/moment";
import { useLazyRefferalsViewListQuery } from "../../redux/api/api";

const ReferralView = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [page, setPage] = useState(1);
  const [list, setList] = useState([]);
  const [overAllCount, setOverALlCount] = useState(1);
  const [pagination, setPagonation] = useState({});
  const [search, setSearch] = useState("");
  const [status_value, setStatus_value] = useState("");
  const [row, setRow] = useState(10);
  const [filter, setFilter] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [btn, setBtn] = useState(false);
  const [ref_amount, setref_amount] = useState(0);

  // RTK QUERY
  const [listApi] = useLazyRefferalsViewListQuery();

  const getList = (
    search_value,
    row_value,
    filter_value,
    from_date,
    to_date,
    status_
  ) => {
    let params = `${location?.state?.data?.id}?page=${page}`;

    if (search_value) {
      params += `&search=${search_value}`;
    }

    if (row_value) {
      params += `&row=${row_value}`;
    }

    if (filter_value) {
      params += `&filter=${filter_value}`;
    }

    if (status_) {
      params += `&status=${status_}`;
    }

    if (from_date) {
      params += `&from_date=${moment(from_date).format("YYYY-MM-DD")}`;
    }

    if (to_date) {
      params += `&to_date=${moment(to_date).format("YYYY-MM-DD")}`;
    }

    setSearch(search_value);
    setRow(row_value);
    setFilter(filter_value);
    setToDate(to_date);
    setFromDate(from_date);
    setStatus_value(status_);
    dispatch(saveLoader(true));
    listApi(params)
      .unwrap()
      .then((res) => {
        dispatch(saveLoader(false));
        setList(res?.user_refferals);
        setref_amount(res?.amount);
        setOverALlCount(
          Math.ceil(res?.pagination?.total / res?.pagination?.per_page)
        );
        setPagonation(res?.pagination);
      })
      .catch((err) => {
        dispatch(saveLoader(false));
        console.log("err", err);
      });
  };

  useEffect(() => {
    if (location?.state?.data?.id) {
      getList(search, row, filter, fromDate, toDate, status_value);
    }
  }, [page]);

  const handlePageChange = (selectedObject) => {
    setPage(selectedObject.selected + 1);
  };

  return (
    <div className="dashRightView home_section">
      <TopHeader type={"referral-view"} />
      <div className="block block-rounded ">
        <div className="block-content">
          <Row>
            <Col md={6}>
              <div className="d-flex flex-column">
                <label className="table-labels f1">
                  Total Count : {pagination?.total}
                </label>
              </div>
            </Col>
          </Row>
          <div className="d-flex ac-jb gap-2">
            <div className="col-md-2 mb-2 p-0">
              <select
                className="form-control custom-select"
                onChange={(e) =>
                  getList(
                    search,
                    e.target.value,
                    filter,
                    fromDate,
                    toDate,
                    status_value
                  )
                }
                value={row}
              >
                <option value={10}>10</option>
                <option value={25}>25</option>
                <option value={50}>50</option>
                <option value={100}>100</option>
              </select>
            </div>
            <div className="col-md-3 mb-2 p-0">
              <input
                className="form-control bg-white px-3"
                placeholder="Eg: User Id"
                onChange={(e) =>
                  getList(
                    e.target.value,
                    row,
                    filter,
                    fromDate,
                    toDate,
                    status_value
                  )
                }
                value={search}
              />
            </div>
          </div>
          <div className="table-custom-design overflow-scroll">
            <table>
              <thead>
                <tr className="text-capitalize text-nowrap">
                  <th>S.NO</th>
                  <th>Referral Name</th>
                  <th>Referred Date</th>
                  <th>Earn Amount (₹)</th>
                  <th>Amount Status</th>
                </tr>
              </thead>
              <tbody>
                {list?.map((item, ind) => {
                  return (
                    <tr key={ind}>
                      <td>{(pagination?.current_page - 1) * row + ind + 1}</td>
                      <td>{item?.name ? item?.name : "-"}</td>
                      <td>
                        {item?.created_at
                          ? moment(item?.created_at).format(
                              "DD-MM-YYYY hh:mm a"
                            )
                          : "-"}
                      </td>
                      <td>{100}</td>
                      <td>
                        {item?.refferal_payment_status ? " Paid" : "Not Paid"}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <div className="page-inner-cont py-2 d-flex justify-content-end">
            <ReactPaginate
              nextLabel="››"
              onPageChange={handlePageChange}
              pageRangeDisplayed={2}
              marginPagesDisplayed={2}
              pageCount={overAllCount}
              previousLabel="‹‹"
              pageClassName="page-item"
              pageLinkClassName="page-link"
              previousClassName="page-item"
              previousLinkClassName="page-link"
              nextClassName="page-item"
              nextLinkClassName="page-link"
              breakLabel="..."
              breakClassName="page-item"
              breakLinkClassName="page-link"
              containerClassName="pagination"
              activeClassName="active"
              renderOnZeroPageCount={null}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReferralView;
